export default "__VITE_ASSET__Dh8tAB5w__"